import { Card, CardContent, CardHeader } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";
import { cn } from "utils/cn";

const PLACEHOLDER_COUNT = 3;
const pulseClass = "bg-border motion-reduce:animate-none";

const MatchCard = ({ variant }) => (
    <Card>
        <CardHeader className="p-[15px]">
            <div className="flex flex-col items-center gap-3 md:flex-row md:items-start">
                <Skeleton className={cn("size-[160px] rounded-full md:hidden", pulseClass)} />
                <Skeleton className={cn("hidden size-[120px] shrink-0 rounded-full md:block", pulseClass)} />
                <div className="flex w-full min-w-0 flex-1 flex-col items-center gap-2 md:items-start">
                    <div className="flex w-full flex-col items-center gap-2 md:flex-row md:items-start md:justify-between">
                        <div className="flex w-full min-w-0 flex-col items-center gap-1 md:items-start">
                            <div className="flex flex-wrap items-center justify-center gap-2 md:justify-start">
                                <Skeleton className={cn("h-5 w-36", pulseClass)} />
                                <Skeleton className={cn("h-6 w-20 rounded-full", pulseClass)} />
                            </div>
                            <Skeleton className={cn("h-4 w-32", pulseClass)} />
                            {variant === "matches" && (
                                <Skeleton className={cn("h-6 w-28 rounded-full", pulseClass)} />
                            )}
                        </div>
                        <div className="flex items-center gap-2">
                            <Skeleton className={cn("size-9 rounded-md", pulseClass)} />
                            <Skeleton className={cn("size-9 rounded-md", pulseClass)} />
                            <Skeleton className={cn("size-9 rounded-md", pulseClass)} />
                        </div>
                    </div>
                </div>
            </div>
        </CardHeader>
        <CardContent className="flex flex-col gap-3 p-[15px] pt-0">
            <Skeleton className={cn("h-4 w-full", pulseClass)} />
            <Skeleton className={cn("h-3 w-24", pulseClass)} />
            <Skeleton className={cn("h-4 w-4/5", pulseClass)} />
            <div className="flex flex-wrap justify-center gap-2 md:justify-start">
                <Skeleton className={cn("h-6 w-16 rounded-full", pulseClass)} />
                <Skeleton className={cn("h-6 w-24 rounded-full", pulseClass)} />
                <Skeleton className={cn("h-6 w-14 rounded-full", pulseClass)} />
            </div>
            {variant === "bookmarks" && (
                <div className="flex justify-end">
                    <Skeleton className={cn("h-8 w-28 rounded-md", pulseClass)} />
                </div>
            )}
        </CardContent>
    </Card>
);

const MatchCardsSkeleton = ({ variant = "matches" }) => (
    <div role="status" aria-busy="true" className="flex flex-col gap-3" data-variant={variant}>
        <span className="sr-only">Loading…</span>
        <div aria-hidden="true" className="flex flex-col gap-3">
            {Array.from({ length: PLACEHOLDER_COUNT }, (_, index) => (
                <MatchCard key={index} variant={variant} />
            ))}
        </div>
    </div>
);

export default MatchCardsSkeleton;
